module.exports = __webpack_public_path__ + "img/uz.uza4de118.svg";